import request from "@/utils/request";

export function getCoachesList(params = {}) {
  return request({
    method: "get",
    url: "/users/coach/list/",
    data: params
  });
}

export function markCoach(params = {}) {
  return request({
    method: "post",
    url: "/users/mark/coach/",
    data: params
  });
}

